export const environment = {
  apiUrl: 'https://api-bo-daniel.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://spb-common-api-daniel.internal.sparbankensyd.se/service',
  domain: 'bo.internal.sparbankensyd.se',
  testMode: true,
  production: false
}
